import {
  Instagram,
  Facebook,
  Twitter,
  Youtube,
  Linkedin,
  MessageCircle,
  Music,
  Send,
  Link as LinkIcon,
} from "lucide-react";

/**
 * Supported social platforms.
 * `icon` is a lucide-react component. For platforms lucide doesn't ship
 * (WhatsApp, TikTok), we render a lightweight inline SVG in the renderer.
 */
export const SOCIAL_PLATFORMS = [
  { value: "instagram", label: "Instagram", placeholder_url: "https://instagram.com/nelumdining", placeholder_handle: "@nelumdining" },
  { value: "facebook", label: "Facebook", placeholder_url: "https://facebook.com/nelumdining", placeholder_handle: "Nelum Dining" },
  { value: "whatsapp", label: "WhatsApp", placeholder_url: "https://wa.me/622112345678", placeholder_handle: "+62 21 1234 5678" },
  { value: "tiktok", label: "TikTok", placeholder_url: "https://tiktok.com/@nelumdining", placeholder_handle: "@nelumdining" },
  { value: "twitter", label: "X / Twitter", placeholder_url: "https://x.com/nelumdining", placeholder_handle: "@nelumdining" },
  { value: "youtube", label: "YouTube", placeholder_url: "https://youtube.com/@nelumdining", placeholder_handle: "Nelum Dining" },
  { value: "linkedin", label: "LinkedIn", placeholder_url: "https://linkedin.com/company/nelumdining", placeholder_handle: "Nelum Dining" },
  { value: "telegram", label: "Telegram", placeholder_url: "https://t.me/nelumdining", placeholder_handle: "@nelumdining" },
  { value: "threads", label: "Threads", placeholder_url: "https://threads.net/@nelumdining", placeholder_handle: "@nelumdining" },
  { value: "other", label: "Other / Custom", placeholder_url: "https://example.com", placeholder_handle: "Link" },
];

export function getPlatform(value) {
  return SOCIAL_PLATFORMS.find((p) => p.value === value) || SOCIAL_PLATFORMS.at(-1);
}

const LUCIDE_MAP = {
  instagram: Instagram,
  facebook: Facebook,
  twitter: Twitter,
  youtube: Youtube,
  linkedin: Linkedin,
  telegram: Send,
  threads: MessageCircle,
  other: LinkIcon,
};

// Inline SVGs for platforms not shipped by lucide.
function WhatsAppIcon({ size = 16, strokeWidth = 1.5, className = "" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      <path d="M20.52 3.48A11.94 11.94 0 0 0 12.05 0C5.5 0 .2 5.3.2 11.85c0 2.09.55 4.13 1.6 5.93L0 24l6.35-1.66a11.9 11.9 0 0 0 5.7 1.45h.01c6.55 0 11.85-5.3 11.85-11.85 0-3.17-1.23-6.15-3.39-8.46Z" />
      <path d="M17.4 14.38c-.29-.14-1.72-.85-1.99-.95-.27-.1-.46-.14-.66.14-.19.29-.75.95-.92 1.14-.17.19-.34.22-.63.07-.29-.14-1.23-.45-2.34-1.44-.86-.77-1.44-1.72-1.61-2.01-.17-.29-.02-.44.13-.58.13-.13.29-.34.44-.51.14-.17.19-.29.29-.48.09-.19.05-.36-.02-.5-.07-.14-.66-1.58-.9-2.16-.24-.57-.48-.49-.66-.5-.17-.01-.36-.01-.55-.01-.19 0-.5.07-.76.36-.26.29-1 .98-1 2.39s1.03 2.77 1.17 2.96c.14.19 2.02 3.08 4.89 4.32.68.29 1.22.47 1.63.6.68.22 1.31.19 1.8.12.55-.08 1.72-.7 1.96-1.38.24-.68.24-1.26.17-1.38-.07-.12-.26-.19-.55-.34Z" />
    </svg>
  );
}

function TikTokIcon({ size = 16, strokeWidth = 1.5, className = "" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      <path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5" />
    </svg>
  );
}

export function SocialIcon({ platform, size = 16, strokeWidth = 1.5, className = "" }) {
  if (platform === "whatsapp") return <WhatsAppIcon size={size} strokeWidth={strokeWidth} className={className} />;
  if (platform === "tiktok") return <TikTokIcon size={size} strokeWidth={strokeWidth} className={className} />;
  const Cmp = LUCIDE_MAP[platform] || Music;
  return <Cmp size={size} strokeWidth={strokeWidth} className={className} />;
}
